/* Knurlhouse motion: vanilla, no dependencies. Ported from the Claude Design "Turntable" export
   (docs/design/claude-design/knurlhouse-motion.js) and started once per page and per section reload. */
(function () {
  if (window.KHMotion) return;
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function rot(d) { return 'rotate(' + d + 'deg)'; }
  var LOOPS = {
    // thumb flick: fast 720°, long ease-out, rest
    knurl: function (el) { return el.animate([{ transform: rot(0), easing: 'cubic-bezier(.12,.75,.22,1)' }, { transform: rot(720), offset: .62 }, { transform: rot(720) }], { duration: 3600, iterations: Infinity }); },
    // beads slide back and forth along the open band
    roll: function (el) { return el.animate([{ transform: rot(-34) }, { transform: rot(34) }], { duration: 1500, iterations: Infinity, direction: 'alternate', easing: 'cubic-bezier(.45,0,.25,1)' }); },
    // eight 45° steps with a hold on each face
    glide: function (el) { return el.animate([{ transform: rot(0) }, { transform: rot(360) }], { duration: 6000, iterations: Infinity, easing: 'cubic-bezier(.45,0,.55,1)' }); },
    facet: function (el) { var k = []; for (var i = 0; i < 8; i++) { k.push({ offset: i / 8, transform: rot(i * 45), easing: 'cubic-bezier(.6,0,.15,1)' }); k.push({ offset: i / 8 + .06, transform: rot((i + 1) * 45) }); } k.push({ offset: 1, transform: rot(360) }); return el.animate(k, { duration: 7200, iterations: Infinity }); },
    idle: function (el) { return el.animate([{ transform: rot(0) }, { transform: rot(360) }], { duration: 16000, iterations: Infinity }); }
  };
  function angleOf(el) { var m = getComputedStyle(el).transform; if (!m || m === 'none') return 0; var v = m.match(/matrix\(([^)]+)\)/); if (!v) return 0; v = v[1].split(','); return Math.atan2(+v[1], +v[0]) * 180 / Math.PI; }

  function init(root) {
    var off = [], ac = new AbortController(), sig = { signal: ac.signal };
    off.push(function () { ac.abort(); });
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { (e.target.__kh || []).forEach(function (f) { f(e.isIntersecting); }); }); }, { threshold: .12 });
    off.push(function () { io.disconnect(); });
    function watch(el, fn) { el.__kh = (el.__kh || []).concat(fn); io.observe(el); off.push(function () { el.__kh = []; }); }
    function all(sel) { return [].slice.call(root.querySelectorAll(sel)); }

    // 1. Looping ring motions, paused off-screen
    all('[data-spin]').forEach(function (el) {
      var mk = LOOPS[el.getAttribute('data-spin')]; if (!mk || RM) return;
      var a = mk(el); a.pause(); a.currentTime = +el.getAttribute('data-delay') || 0;
      watch(el, function (v) { v ? a.play() : a.pause(); });
      off.push(function () { a.cancel(); });
    });

    // 2. Reveals: fade-up, or a clip wipe for display type.
    //    Elements below the fold are set to their hidden state up front and start revealing a little
    //    before they scroll into view. Starting the animation only once they were on screen showed the
    //    full word, snapped it hidden, then wiped it back in (the "cut for a second" flash).
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var narrow = window.matchMedia && matchMedia('(max-width: 759px)').matches;
    var rio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting && e.target.__khReveal) { e.target.__khReveal(); rio.unobserve(e.target); } });
    }, { rootMargin: '0px 0px 18% 0px', threshold: 0 });
    off.push(function () { rio.disconnect(); });
    all('[data-reveal],[data-wipe]').forEach(function (el) {
      if (RM) return;
      // Anything already on screen when the page loads stays visible.
      var box = el.getBoundingClientRect();
      if (box.top < vh && box.bottom > 0) return;
      // On phones big headings fade up instead of wiping: a half-clipped word read as a glitch there.
      var wipe = el.hasAttribute('data-wipe') && !narrow, d = +(el.getAttribute('data-reveal') || el.getAttribute('data-wipe')) || 0;
      var from = wipe ? { clipPath: 'inset(-5% -40% 100% -10%)', transform: 'translateY(.3em)' } : { opacity: 0, transform: 'translateY(32px)' };
      var to = wipe ? { clipPath: 'inset(-5% -40% -12% -10%)', transform: 'none' } : { opacity: 1, transform: 'none' };
      Object.keys(from).forEach(function (k) { el.style[k] = from[k]; });
      el.__khReveal = function () {
        var anim = el.animate([from, to], { duration: wipe ? (narrow ? 700 : 950) : (narrow ? 600 : 800), delay: d, easing: 'cubic-bezier(.2,.75,.2,1)', fill: 'forwards' });
        anim.onfinish = function () { Object.keys(from).forEach(function (k) { el.style[k] = ''; }); anim.cancel(); };
      };
      rio.observe(el);
      off.push(function () { el.__khReveal = null; Object.keys(from).forEach(function (k) { el.style[k] = ''; }); });
    });

    // 3. Degree readouts: sum of all [data-readout-src] rotations in the same [data-readout-group]
    all('[data-readout]').forEach(function (el) {
      var g = el.closest('[data-readout-group]') || root, srcs = [].slice.call(g.querySelectorAll('[data-readout-src]')), raf, seen = true;
      watch(g, function (v) { seen = v; });
      (function loop() {
        if (seen) { var d = 0; srcs.forEach(function (s) { d += angleOf(s); }); el.textContent = String(Math.round(((d % 360) + 360) % 360)).padStart(3, '0') + '°'; }
        raf = requestAnimationFrame(loop);
      })();
      off.push(function () { cancelAnimationFrame(raf); });
    });

    // 4. Marquee
    all('[data-marquee]').forEach(function (el) {
      if (RM) return;
      var a = el.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-50%)' }], { duration: +el.getAttribute('data-marquee') || 30000, iterations: Infinity });
      off.push(function () { a.cancel(); });
    });

    // 5. Drag to spin with inertia, settling back to an idle drift.
    //    The ring follows the pointer (finger or mouse) around its centre, so circular gestures turn it. Only the ring and a
    //    narrow margin around it capture touch (CSS touch-action: none on .kht-spin__ring, plus the touch handlers below);
    //    touches beside it still scroll the page.
    all('[data-drag-spin]').forEach(function (el) {
      var t = el.querySelector('[data-drag-target]'); if (!t) return;
      var hit = el.querySelector('.kht-spin__ring') || t;
      var idle = RM ? 0 : .3, ang = 0, vel = idle, drag = false, lx = 0, la = 0, touch = false, raf;
      (function loop() { if (!drag) { ang += vel; vel += (idle - vel) * .015; } t.style.transform = rot(ang); raf = requestAnimationFrame(loop); })();
      function angleAt(e) { var r = hit.getBoundingClientRect(); return Math.atan2(e.clientY - (r.top + r.height / 2), e.clientX - (r.left + r.width / 2)) * 180 / Math.PI; }
      // A touch counts as on the ring within a circle a little wider than it, so a thumb on the rim or on
      // the Glide's arc outside it still turns the ring.
      function near(p) { var r = hit.getBoundingClientRect(), dx = p.clientX - (r.left + r.width / 2), dy = p.clientY - (r.top + r.height / 2); return Math.sqrt(dx * dx + dy * dy) <= r.width / 2 * 1.25; }
      el.addEventListener('pointerdown', function (e) {
        touch = e.pointerType !== 'mouse';
        if (touch && !near(e)) return; // beside the ring: let the page scroll
        drag = true; lx = e.clientX; la = angleAt(e); vel = 0;
        el.setPointerCapture(e.pointerId);
      }, sig);
      el.addEventListener('pointermove', function (e) {
        if (!drag) return;
        // Touch and mouse both follow the pointer around the ring's centre, so a full circle with the
        // mouse turns it a full 360° (left/right-only tracking reversed it halfway round).
        var a = angleAt(e), d = a - la; la = a;
        if (d > 180) d -= 360; else if (d < -180) d += 360;
        vel = d; ang += d;
      }, sig);
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (n) { el.addEventListener(n, function () { drag = false; }, sig); });
      // iOS Safari sometimes applies the ring's touch-action late (for example just after the section
      // has revealed), so the first touch scrolled the page instead of turning the ring. Cancelling the
      // touch itself keeps the gesture on the ring. Touches beside the ring still scroll.
      var nonPassive = { passive: false, signal: ac.signal }, held = false;
      el.addEventListener('touchstart', function (e) { held = e.touches.length === 1 && near(e.touches[0]); if (held && e.cancelable) e.preventDefault(); }, nonPassive);
      el.addEventListener('touchmove', function (e) { if (held && e.cancelable) e.preventDefault(); }, nonPassive);
      off.push(function () { cancelAnimationFrame(raf); });
    });

    // 5b. The Roll: an open band, so its beads slide along the arc instead of turning 360°.
    //     Each bead is dragged on its own, pushes its neighbours instead of passing through them, and
    //     stops at the fixed end balls. Angles are degrees clockwise from the top; the opening is at the bottom.
    all('[data-drag-spin]').forEach(function (el) {
      var box = el.querySelector('[data-beads]'); if (!box) return;
      var hit = el.querySelector('.kht-spin__ring') || box;
      var pos = [].slice.call(box.querySelectorAll('[data-at]'));
      var th = pos.map(function (p) { return +p.getAttribute('data-at'); });
      var n = th.length, END = 131, GAP = 19; // last bead centre before an end ball; bead-to-bead spacing
      var grab = -1, last = -1, la = 0, vel = 0, raf, used = false;
      function lo(i) { return -END + i * GAP; }
      function hi(i) { return END - (n - 1 - i) * GAP; }
      function place(i, a) {
        var was = th[i];
        th[i] = Math.max(lo(i), Math.min(hi(i), a));
        for (var j = i + 1; j < n; j++) th[j] = Math.max(th[j], th[j - 1] + GAP);
        for (j = i - 1; j >= 0; j--) th[j] = Math.min(th[j], th[j + 1] - GAP);
        return th[i] - was;
      }
      function draw() { pos.forEach(function (p, i) { p.style.transform = rot(Math.round(th[i] * 100) / 100); }); }
      function angleAt(e) { var r = hit.getBoundingClientRect(); return Math.atan2(e.clientX - (r.left + r.width / 2), (r.top + r.height / 2) - e.clientY) * 180 / Math.PI; }
      function wrap(d) { return d > 180 ? d - 360 : d < -180 ? d + 360 : d; }
      // After release a bead glides a little on the wire and stops; it never bounces off an end.
      (function loop() {
        if (grab < 0 && last >= 0 && Math.abs(vel) > 0.05) { var moved = place(last, th[last] + vel); vel = Math.abs(moved) < Math.abs(vel) * 0.5 ? 0 : vel * 0.86; draw(); }
        raf = requestAnimationFrame(loop);
      })();
      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' && !hit.contains(e.target)) return; // beside the ring: let the page scroll
        var a = angleAt(e), best = 0;
        th.forEach(function (t, i) { if (Math.abs(wrap(a - t)) < Math.abs(wrap(a - th[best]))) best = i; });
        grab = last = best; la = a; vel = 0; used = true;
        el.setPointerCapture(e.pointerId);
      }, sig);
      el.addEventListener('pointermove', function (e) {
        if (grab < 0) return;
        var a = angleAt(e), d = wrap(a - la); la = a;
        vel = place(grab, th[grab] + d); draw();
      }, sig);
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (n) { el.addEventListener(n, function () { grab = -1; if (RM) vel = 0; }, sig); });
      // A one-time nudge the first time it scrolls into view, so it's clear the beads move.
      var nudged = RM;
      watch(el, function (v) {
        if (!v || nudged || used) return; nudged = true;
        var i = 3, base = th[i], t0 = performance.now();
        (function step(now) {
          if (used) return;
          var k = Math.min(1, (now - t0) / 1600);
          place(i, base + 26 * Math.sin(Math.PI * k)); draw();
          if (k < 1) requestAnimationFrame(step);
        })(t0);
      });
      off.push(function () { cancelAnimationFrame(raf); });
    });

    // 6. "How they move": one stage, crossfading per step. Steps drive it on wide screens, tabs on narrow ones.
    all('[data-kht-move]').forEach(function (sec) {
      var frames = [].slice.call(sec.querySelectorAll('[data-frame]')),
        steps = [].slice.call(sec.querySelectorAll('[data-step]')),
        tabs = [].slice.call(sec.querySelectorAll('[data-tab]')),
        idx = sec.querySelector('[data-move-index]');
      function set(i) {
        frames.forEach(function (f, j) { f.classList.toggle('is-active', i === j); });
        steps.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', String(i === j)); });
        if (idx) idx.textContent = String(i + 1).padStart(2, '0');
      }
      var sio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && getComputedStyle(e.target).display !== 'none' && sec.offsetWidth >= 760) set(+e.target.getAttribute('data-step')); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { sio.observe(s); s.addEventListener('click', function () { set(+s.getAttribute('data-step')); }, sig); });
      tabs.forEach(function (t, j) { t.addEventListener('click', function () { set(j); }, sig); });
      off.push(function () { sio.disconnect(); });
      set(0);
    });

    // 7. Ring rows: finish swatches swap the product photo, and the row's links open that finish
    all('[data-kht-row]').forEach(function (row) {
      var img = row.querySelector('[data-row-img]'), sws = [].slice.call(row.querySelectorAll('[data-swatch]'));
      var links = [].slice.call(row.querySelectorAll('[data-finish-link]'));
      sws.forEach(function (b) {
        b.addEventListener('click', function () {
          sws.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          var src = b.getAttribute('data-img');
          if (img && src) { img.removeAttribute('srcset'); img.src = src; }
          // Both halves of the finish link change together: Shopify renders option_values, the page reads finish.
          var f = b.getAttribute('data-finish'), vid = b.getAttribute('data-value-id');
          if (f) links.forEach(function (a) {
            var u = new URL(a.href, location.href);
            if (vid) u.searchParams.set('option_values', vid); else u.searchParams.delete('option_values');
            u.searchParams.set('finish', f);
            a.href = u.pathname + u.search;
          });
        }, sig);
      });
    });

    // 8. "A day with it": arrows, counter, progress line, and mouse drag-to-scroll (touch scrolls natively)
    all('[data-kht-day]').forEach(function (sec) {
      var track = sec.querySelector('[data-day-track]'), cards = [].slice.call(sec.querySelectorAll('[data-day-card]'));
      if (!track || !cards.length) return;
      var prev = sec.querySelector('[data-day-prev]'), next = sec.querySelector('[data-day-next]'),
        idx = sec.querySelector('[data-day-index]'), bar = sec.querySelector('[data-day-bar]');
      function step() { return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth; }
      function sync() {
        var max = track.scrollWidth - track.clientWidth, x = track.scrollLeft;
        var i = Math.min(cards.length - 1, Math.round(x / step()));
        if (max > 0 && x >= max - 2) i = cards.length - 1;
        if (idx) idx.textContent = String(i + 1).padStart(2, '0');
        if (prev) prev.disabled = x <= 2;
        if (next) next.disabled = max <= 0 || x >= max - 2;
        if (bar) { var w = max > 0 ? track.clientWidth / track.scrollWidth : 1; bar.style.width = (w * 100) + '%'; bar.style.left = (max > 0 ? (x / max) * (1 - w) * 100 : 0) + '%'; }
      }
      function go(dir) { track.scrollBy({ left: dir * step(), behavior: RM ? 'auto' : 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { go(-1); }, sig);
      if (next) next.addEventListener('click', function () { go(1); }, sig);
      track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true, signal: ac.signal });
      window.addEventListener('resize', sync, sig);
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); go(e.key === 'ArrowRight' ? 1 : -1); }
      }, sig);

      var down = null, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = { x: e.clientX, left: track.scrollLeft }; moved = false;
      }, sig);
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - down.x;
        if (!moved && Math.abs(dx) > 4) { moved = true; track.classList.add('is-dragging'); }
        if (moved) track.scrollLeft = down.left - dx;
      }, sig);
      window.addEventListener('pointerup', function () {
        if (!down) return;
        var was = moved, start = down.left; down = null;
        if (!was) return;
        // Settle on the nearest card in the direction of the drag, then let snapping take over again.
        var s = step(), i = track.scrollLeft > start ? Math.ceil(track.scrollLeft / s - 0.15) : Math.floor(track.scrollLeft / s + 0.15);
        track.scrollTo({ left: i * s, behavior: RM ? 'auto' : 'smooth' });
        setTimeout(function () { track.classList.remove('is-dragging'); }, 350);
      }, sig);
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, { capture: true, signal: ac.signal });
      // The progress line is also a scrubber: press or drag anywhere on it to move through the cards.
      var barBox = bar && bar.parentElement, scrub = false;
      function scrubTo(e) {
        var r = barBox.getBoundingClientRect(), max = track.scrollWidth - track.clientWidth;
        var w = bar.getBoundingClientRect().width, f = (e.clientX - r.left - w / 2) / Math.max(1, r.width - w);
        track.scrollLeft = Math.max(0, Math.min(1, f)) * max;
      }
      if (barBox) {
        barBox.addEventListener('pointerdown', function (e) {
          scrub = true; barBox.setPointerCapture(e.pointerId); track.classList.add('is-dragging'); barBox.classList.add('is-scrubbing'); scrubTo(e); e.preventDefault();
        }, sig);
        barBox.addEventListener('pointermove', function (e) { if (scrub) scrubTo(e); }, sig);
        ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (n) {
          barBox.addEventListener(n, function () {
            if (!scrub) return; scrub = false; barBox.classList.remove('is-scrubbing');
            var st = step(); track.scrollTo({ left: Math.round(track.scrollLeft / st) * st, behavior: RM ? 'auto' : 'smooth' });
            setTimeout(function () { track.classList.remove('is-dragging'); }, 350);
          }, sig);
        });
      }
      sync();
    });

    return function () { off.forEach(function (f) { f(); }); };
  }
  window.KHMotion = { init: init };

  var kill = null;
  function boot() { if (kill) kill(); kill = init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function () { setTimeout(boot, 0); });
})();
